import { Alert, AlertColor, Snackbar } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Color from "color";
import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Iframe from 'react-iframe';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import appContext from '../../appContext/index';
import ContentCard from '../../components/ContentCard/index';
import ConversationalFormSettingsDialog from '../../components/CreateForm/DialogBase/ConversationalFormSettingsDialog';
import DeleteConfirmationModal from '../../components/Custom/Modals/DeleteConfirmationModal';
import ExitConfirmationModal from '../../components/Custom/Modals/ExitConfirmationModal';
import PublishAlertModal from '../../components/Custom/Modals/PublishAlertModal';
import FormSettings from '../../components/FormSettings/index';
import Slides from '../../components/Slides/index';
import { deleteFormByUUID, getFormsByUUID, getGroups, getPreviewLink, insertForms, sendWaymoreSystemEvents, updateFormByUUID, } from '../../Services/API';
import { addValueAndMaintainLength, conversationalFormEvents, conversationalFormsURL, endpointRegex, getCookie, handleDropdownData, initialContextMenu, isCenteredContant, parseUrl, unregisterMethods } from '../../Utils/common';
import { addressFormat, AppointmentJs, calculativeFieldFormat, captureFormat, contactInfoFormat, countryFormat, dateFormat, datetimeFormat, domainFormat, dropDownFormat, emailFormat, employeeDropdownFormat, formFormat, geolocationFormat, google, htmlFormat, inputFormat, inputPhoneFormat, multiInputFormat, multiselectFormat, nameSurnameFormat, paymentFormat, richTextFormat, selectFormat, singleSelectFormat, socialMedia, timeFormat, timeZoneFormat } from '../../Utils/formFields';
import { PopupContent } from '../../Utils/PopupContents';
import { IDataFromModal, selectedGroupPropType } from '../Workspace/interface.js';
import FormBodyHeader from './FormBodyHeader';
import FormHeader from './FormHeader';
import PreviewBodyHeader from './PreviewBodyHeader';
import PreviewHeader from './PreviewHeader';
import './style.scss';
import {
    BodyContainer,
    BodyContentContainer,
    ContentScreenLayout,
    IframeParentContainer,
    LayoutRoot,
    PreviewBodyContainer,
    PreviewBodyContentContainer,
    PreviewRootContainer,
    QuestionPanelLayout,
    QuestionScreenLayout,
    RootContainer, ShareBodyContainer, ShareBodyContentContainer, ShareRootContainer
} from './styled';

import { cloneDeep } from 'lodash';
import Embedding from '../Embedding';
import { sidebarValueConstants } from '../Workspace/sidebarutils';
import { getFormattedResponse, getFormattedUniqueData } from './handlers';

export default function Form() {
    const location = useLocation()
    const navigate = useNavigate()
    const popoverSubmit = useRef<any>()

    const [searchParams] = useSearchParams()
    const isNewForm = Boolean(Number(searchParams.get('newForm')))

    const { setuploadState, setRemoveIpOptions, setAddIpOptions, setOptionCount, setSelectedMode, setGroupsList, groupsList, contactGroup, setContactGroup, setOpenLogicDialog } = useContext(appContext)

    const [popupOpen, setPopupOpen] = useState(true)
    const [exitPopupOpen, setExitPopupOpen] = useState(false)
    const [applicationPopupData, setApplicationPopupData] = useState<string>("feedback");
    const [departmentPopupData, setDepartmentPopupData] = useState<string>("hr")
    const [casePopupData, setCasePopupData] = useState<string>("")
    const [questionFormData, setQuestionFormData] = useState<any[]>([])
    const [allQuestionTypes, setAllQuestionTypes] = useState(false)
    const [landingPage, setLandingPage] = useState(true)
    const [endPointAvailable, setEndPointAvailable] = useState<boolean>(true);
    const [recordVideo, setRecordVideo] = useState<boolean>(false);
    const [showRecordVideo, setShowRecordVideo] = useState<boolean>(false);
    const [submitToggle, setSubmitToggle] = useState<boolean>(false);
    const [submitType, setSubmitType] = useState<string>("");
    const [finalQuestionRes, setFinalQuestionRes] = useState<string>("")
    const [dataFormSettings, setDataFormSettings] = useState<any[]>([])
    const [successPopupOpen, setSuccessPopupOpen] = useState<boolean>(false)
    const [formUUID, setFormUUID] = useState<string>("")
    const [editUUID, setEditUUID] = useState<string>(location?.state?.formUUID)
    const [selectedFormSettings, setSelectedFormSettings] = useState<any>({ index: '', fields: '' })
    const [prevSelected, setPrevSelected] = useState<any>({ index: '', fields: '' })
    const [toasterOpen, setToasterOpen] = useState<boolean>(false);
    const [toasterMessage, setToasterMessage] = useState<String>('');
    const [toasterSeverity, setToasterSeverity] = useState<any>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [inputType, setInputType] = useState<string>("select");
    const [dragDisable, setDragDisable] = useState<boolean>(false)
    const [sendResponseToUser, setSendResponseToUser] = useState<boolean>(false)
    const [saveContact, setSaveContact] = useState<boolean>(false)
    const [gaAvailable, setGaAvailable] = useState<boolean>(false)
    const [gtmAvailable, setGtmAvailable] = useState<boolean>(false)
    const [gaTrackingId, setGaTrackingId] = useState<string>("")
    const [gtmTrackingId, setGtmTrackingId] = useState<string>("")
    const [previewType, setPreviewType] = useState<'mobile' | 'tab' | 'pc'>('pc')
    const [trigger] = useState<boolean>(false)
    const [errorTrigger, setErrorTrigger] = useState<boolean>(false)
    const [disableIsPublished, setdisableIsPublished] = useState<boolean>(true)
    const [dataFromModal, setDataFromModal] = useState<IDataFromModal>({
        name: "",
        backGround: location?.state?.formUUID ? "" : "https://waymore.io/wp-content/uploads/2022/12/image_2022_12_23T11_58_29_928Z.png",
        submitPageBackground: location?.state?.formUUID ? "" : "https://waymore.io/wp-content/uploads/2022/12/image_2022_12_23T11_58_29_928Z.png",
        landingPageBackground: location?.state?.formUUID ? "" : "https://waymore.io/wp-content/uploads/2022/12/image_2022_12_23T11_58_29_928Z.png",
        finalContent: "",
        html: "",
        isLanding: true,
        landTextColor: "#ffffff",
        landBtnColor: "#7654ff",
        backgroundColor: "#3d3d3d",
        landBtnFont: "Poppins",
        landBtnText: "Let's get started",
        landContentType: "custom",
        landCustomContentColour: "#ffffff",
        landContainerContentColour: "#ffffff",
        landCustomContentFont: "Poppins",
        textColor: "#ffffff",
        btnColor: "#00274E",
        btnTextColor: "#ffffff",
        loaderColor: "#ffffff",
        endPointAvailable: location.state?.dataFromModal?.additionalProperties?.endPoinDetails?.url ? true : false,
        recordVideo: location.state?.dataFromModal?.recordVideo ? true : false,
        sendResponseToUser: location.state?.dataFromModal?.sendResponseToUser ? true : false,
        showRecordVideo: location.state?.dataFromModal?.showRecordVideo ? true : false,
        saveContact: location.state?.dataFromModal?.saveContact ? true : false,
        gaAvailable: location.state?.dataFromModal?.gaAvailable ? true : false,
        gtmAvailable: location.state?.dataFromModal?.gtmAvailable ? true : false,
        gaTrackingId: location.state?.dataFromModal?.gaTrackingId,
        gtmTrackingId: location.state?.dataFromModal?.gtmTrackingId,
        formLink: location.state?.dataFromModal?.formLink || "",
        allowNewResponse: location.state?.dataFromModal?.allowNewResponse ?? false,
        endPoint: "",
        endPointMethod: "",
        endPointHeaders: "",
        sendResponseInEmail: {
            isActive: location.state?.dataFromModal?.sendResponseInEmail?.isActive ?? false,
            sendersEmail: location.state?.dataFromModal?.sendResponseInEmail?.sendersEmail ?? "",
            recipientsEmail: location.state?.dataFromModal?.sendResponseInEmail?.recipientsEmail ?? [],
            subject: location.state?.dataFromModal?.sendResponseInEmail?.subject ?? ""
        },
        publishedAt: location.state?.dataFromModal?.publishedAt ?? null,
        templateId: location.state?.dataFromModal?.templateId || ""
    })
    const [watermark, setWatermark] = useState<boolean>(true);
    const [watermarkPosition, setWatermarkPosition] = useState<string>("bottom-right");
    const [masterType, setMasterType] = useState<any>(singleSelectFormat);
    const [selectedType, setSelectedType] = useState<string>("select");
    const [addNewIndex, setaddNewIndex] = useState<number | null>(null);
    const formValidator = useForm<any>({
        defaultValues: singleSelectFormat
    })
    const [optionIndex, setOptionIndex] = useState<number>(0);
    const [contextMenu, setContextMenu] = useState(initialContextMenu)
    const [OpenDeletePopup, setOpenDeletePopup] = useState<boolean>(false)
    const [formDelete, setFormDelete] = useState<boolean>(false)
    const [contactFieldWarningOpen, setContactFieldWarningOpen] = useState<boolean>(false)
    const [delIndex, setDelIndex] = useState<number | null>(null)
    const [errorType, setErrorType] = useState<AlertColor>("success");
    const [errorMessage, setErrorMessage] = useState<string>("updated successfully");
    const [toastr, setToastr] = useState<any>(false);
    const [historyState, setHistoryState] = useState<any>([])
    const [checked, setChecked] = useState(false)
    const [isfetchFromApi, setIsFetchFromApi] = useState<boolean>(false)
    const [redoState, setRedoState] = useState<any>([])
    const [dropdown, setDropdown] = useState<boolean>(false);
    const [previewMode, setPreviewMode] = useState<boolean>(false);
    const [shareMode, setShareMode] = useState<boolean>(false)
    const finalQuestionRef: any = useRef<string>("");
    finalQuestionRef.current = finalQuestionRes
    const questionFormDataRef: any = useRef<any>(null);
    questionFormDataRef.current = questionFormData

    const methods = useForm({
        defaultValues: formFormat
    })

    const handlingModalData = () => {
        setPopupOpen(false)
    }

    const getContactGroupName = (contactGroupData: any): string => {
        if (!contactGroupData) return "";
        if (typeof contactGroupData === "string") return contactGroupData;
        return (
            contactGroupData?.name ||
            contactGroupData?.data?.name ||
            contactGroupData?.label ||
            ""
        );
    };

    const getContactGroup = (selectedGroup: string) => {
        if (selectedGroup) {
            const selectGroup: Array<selectedGroupPropType> = groupsList?.filter((group: any) => group?.data?.name === selectedGroup)
            return selectGroup.length > 0 ? selectGroup[0]?.data : {}
        } else {
            return {}
        }
    }
    const handleValidation = (data: any) => {
        for (let [index, eachQuestion] of data.entries()) {
            try {
                if (eachQuestion.isTimeLimitEnabled) {
                    if (eachQuestion.timeLimit.length === 0) {
                        throw new Error("Time Limit is required")
                    }
                    if (!(eachQuestion.timeLimit.includes("m") || eachQuestion.timeLimit.includes("s"))) {
                        throw new Error("Time Limit has to be m/s")
                    }
                }
                if (!['appointment', "payment"].includes(eachQuestion?.type)) {
                    if (!eachQuestion?.title) {
                        throw new Error("Question is required")
                    } else if (['multi-select', 'select', 'dropdown', "image-select", "image-multi-select"].includes(eachQuestion?.type)) {
                        if (!eachQuestion?.options?.length && !eachQuestion?.fetchFromApi && !eachQuestion.dropDependedName) {
                            throw new Error(eachQuestion?.type !== 'dropdown' ? "Option is missing" : "Options are required for Dropdown")
                        }
                        if (!eachQuestion?.fetchFromApi && !eachQuestion.dropDependedName) {
                            eachQuestion?.options?.forEach((option: any) => {
                                if (!option.value && option.type !== 'otherField') {
                                    throw new Error(eachQuestion?.type !== 'dropdown' ? "Option is missing" : "Options are required for Dropdown")
                                }
                                if (["image-select", "image-multi-select"].includes(eachQuestion?.type) && !option.img && option.type !== 'otherField') {
                                    throw new Error("Image for an option is missing")
                                }
                            })
                        }
                        if (eachQuestion?.type === 'dropdown' && eachQuestion?.fetchFromApi) {
                            if (!eachQuestion?.dropdownApiData?.dropdown_endPoint) {
                                throw new Error("API URL is required")
                            }
                            if (eachQuestion?.dropdownApiData?.dropdown_endPointHeaders) {
                                try {
                                    JSON.parse(eachQuestion?.dropdownApiData?.dropdown_endPointHeaders);
                                    if (!Object.keys(JSON.parse(eachQuestion?.dropdownApiData?.dropdown_endPointHeaders || "{}")).length) {
                                        throw new Error("invalid Headers")
                                    }
                                } catch (e: any) {
                                    setSelectedFormSettings({ index: index, fields: eachQuestion })
                                    setErrorType('error')
                                    setErrorMessage(e?.message || 'invalid Headers')
                                    setToastr(true)
                                    setErrorTrigger((prev) => !prev)
                                    return false
                                }
                            }

                            if (!eachQuestion?.dropdownApiData.dropdown_maxVal && eachQuestion?.dropdownApiData.dropdown_maxVal !== '0') {
                                throw new Error("Max value is required")
                            }

                        }
                        if (eachQuestion?.type === 'dropdown') {
                            if (eachQuestion?.dropdownApiData?.isAdvancedSearch) {
                                if (!eachQuestion?.dropdownApiData?.searchKey) {
                                    throw new Error("Search parameter for advance search is required")
                                }
                                if (!eachQuestion?.dropdownApiData?.searchAfterLength && eachQuestion?.dropdownApiData?.searchAfterLength !== 0) {
                                    throw new Error("Minimum letter for search for advance search is required")
                                }
                            }
                            if (eachQuestion?.callApiOnSelect?.isActivated) {
                                if (!eachQuestion?.callApiOnSelect?.dropdown_endPoint) {
                                    throw new Error("API URL for option based on selection is required")
                                }
                                if (!eachQuestion?.callApiOnSelect?.searchKey) {
                                    throw new Error("Search parameter for option based on selection is required")
                                }
                                if (!eachQuestion?.callApiOnSelect?.dropDependedName) {
                                    throw new Error("Depended Dropdown ID for option based on selection is required")
                                }
                            }
                        }
                    }
                    else if (['input', 'dateAndTime', 'date', 'multi-input', 'phoneNumber', 'time'].includes(eachQuestion?.type)) {
                        eachQuestion?.options?.forEach((option: any) => {
                            if (eachQuestion?.type === 'multi-input' && !option?.question) {
                                throw new Error("Question is missing for an option")
                            }
                        })
                        if (eachQuestion?.type === "input") {
                            const availableTypes = eachQuestion?.options.map((opt: any) => opt.type)
                            if (availableTypes.includes("file") && eachQuestion?.sendFileToApi) {
                                if (eachQuestion["postApiDetails"]?.endpoint) {
                                    const reg = new RegExp(endpointRegex);
                                    if (!reg.test(eachQuestion["postApiDetails"]?.endpoint)) {
                                        throw new Error("Please enter a valid endpoint")
                                    }
                                } else {
                                    throw new Error("Endpoint details is required")
                                }
                            }
                        }
                    } else if (eachQuestion?.type === "employee") {
                        if (!eachQuestion?.organizationChartId) {
                            throw new Error("Organization is required")
                        }
                    }
                } else if (eachQuestion?.type === "payment") {
                    if (!eachQuestion?.paymentId) {
                        throw new Error("paymentId is missing")
                    }
                    if (!eachQuestion?.amount && eachQuestion?.amount !== 0) {
                        throw new Error("amount is missing")
                    }
                } else if (eachQuestion?.type === "appointment") {
                    if (!eachQuestion?.appointment_id) {
                        throw new Error("AppointmentId is required")
                    }
                }

            } catch (e: any) {
                setSelectedFormSettings({ index: index, fields: eachQuestion })
                setSubmitType("selection");
                setPrevSelected({ index: index, fields: eachQuestion });
                setTimeout(() => {
                    setSubmitToggle(!submitToggle);
                }, 100)
                setErrorType('error')
                setErrorMessage(e?.message || 'Something went wrong')
                setToastr(true)
                setErrorTrigger((prev) => !prev)
                return false
            }
        }
        return true
    }

    const handleShowPopup = () => {
        setPopupOpen(true);
        popoverSubmit?.current?.submitHandler();
    };

    const hasEmailOrPhoneField = (questions: any[]): boolean => {
        return questions.some((question: any) => {
            // Check top-level question type
            if (['email', 'phoneNumber'].includes(question?.type)) {
                return true;
            }
            // Check options within input/multi-input fields for email or phoneNumber type
            if (question?.options?.length) {
                return question.options.some((option: any) =>
                    ['email', 'phoneNumber'].includes(option?.type)
                );
            }
            return false;
        });
    };

    const handleFinalSubmit = async (type?: string) => {
        setSubmitType("finalSubmit")
        if (historyState.length) {
            setSubmitToggle(!submitToggle)
        }

        setTimeout(async () => {
            setLoading(true)
            const allQuestionData = [...questionFormDataRef?.current];
            const isValid = handleValidation(allQuestionData);

            const { hasErrorInCreateFormPopup } =
                popoverSubmit?.current?.getValidationStatus();

            if (!isValid) {
                setLoading(false)
                return
            }

            // Enforce contact field validation on "save" only, after latest form changes are synced.
            const isSaveAction = type === "save";
            const isSaveContact = dataFromModal?.saveContact || saveContact || false;
            if (isSaveAction && isSaveContact && !hasEmailOrPhoneField(allQuestionData)) {
                setContactFieldWarningOpen(true);
                setLoading(false);
                return;
            }

            if (hasErrorInCreateFormPopup) {
                setLoading(false);
                handleShowPopup();
                return;
            }

            let newQuestionData = allQuestionData.map((questionData: any, index: number) => {
                questionData['name'] = questionData?.title?.split(" ")?.join("_");
                questionData['qNo'] = index;
                questionData['type'] = (questionData['type'] === "nameAndSurname" || questionData['type'] === "contactInfo" || questionData['type'] === "address" || questionData['type'] === "domain" || questionData['type'] === "email") ? "input" : questionData['type']
                if (["multi-input", "input"].includes(questionData.type)) {
                    questionData.options?.forEach((question: any) => {
                        if (["number", "text"].includes(question.type) && !question?.rule) {
                            question['rule'] = { max: "" }
                        }
                    })
                }
                if (questionData?.isOtherEnabled && (questionData.type === 'select' || questionData.type === 'multi-select' || questionData.type === 'dropdown' || questionData.type === 'image-select' || questionData.type === 'image-multi-select')) {
                    const otherField = questionData.options.find((option: any) => option.type === 'otherField');

                    if (!otherField) {
                        questionData.options = [...questionData.options, { label: "Other", type: "otherField", isOtherEnabled: true }];
                    }
                }
                return questionData
            })

            const publishedAt = type === "save" ? (dataFromModal?.publishedAt || null) : type === "unPublish" ? null : dataFromModal?.isPublished ? dataFromModal?.publishedAt : new Date()
            const isPublishedValue = type === "save" ? dataFromModal?.isPublished ? dataFromModal?.isPublished : 0 : type === "unPublish" ? 0 : 1;

            newQuestionData = getFormattedUniqueData(newQuestionData);

            const finalData: any = {
                "formData": {
                    "principalId": sessionStorage.getItem("principalId"),
                    "isLandingNeeded": dataFromModal?.isLanding,
                    "formName": dataFromModal?.name,
                    "formData": questionFormDataRef?.current.length ? newQuestionData : [],
                    "isPublished": isPublishedValue,
                    "isActive": 1
                },
                "landingPageData": {
                    "principalId": sessionStorage.getItem("principalId"),
                    "formName": dataFromModal?.name,
                    "formContent": dataFromModal?.html || "",
                    "finalContent": dataFromModal?.finalContent || "",
                    "recordVideo": dataFromModal?.recordVideo,
                    "showRecordVideo": dataFromModal?.showRecordVideo || false,
                    "sendResponseToUser": dataFromModal?.sendResponseToUser || false,
                    "gaAvailable": dataFromModal?.gaAvailable || false,
                    "gtmAvailable": dataFromModal?.gtmAvailable || false,
                    "gaTrackingId": dataFromModal?.gaTrackingId || "",
                    "gtmTrackingId": dataFromModal?.gtmTrackingId || "",
                    "isPublished": isPublishedValue,
                    "contactGroup": getContactGroup(dataFromModal?.contactGroup || contactGroup || ""),
                    "saveContact": dataFromModal?.saveContact || saveContact || false,
                    "allowNewResponse": dataFromModal?.allowNewResponse || false,
                    "sendResponseInEmail": {
                        isActive: dataFromModal?.sendResponseInEmail?.isActive ?? false,
                        sendersEmail: dataFromModal?.sendResponseInEmail?.sendersEmail ?? "",
                        recipientsEmail: dataFromModal?.sendResponseInEmail?.recipientsEmail ?? [],
                        subject: dataFromModal?.sendResponseInEmail?.subject ?? ""
                    },
                    "isActive": 1,
                    "publishedAt": publishedAt || null,
                    "style": {
                        "background": dataFromModal?.backGround,
                        "landingPageBackground": dataFromModal?.landingPageBackground,
                        "submitPageBackground": dataFromModal?.submitPageBackground,
                        "foregroundColor": dataFromModal?.textColor,
                        "buttonColor": dataFromModal?.btnColor,
                        "backgroundColor": dataFromModal?.backgroundColor,
                        "fontFamily": "Poppins, sans-serif",
                        "landingPageButtonColor": dataFromModal?.landBtnColor || "",
                        "landingPageContentType": dataFromModal?.landContentType || "custom",
                        "landingPageCustomContentColour": dataFromModal?.landCustomContentColour || "#ffffff",
                        "landingPageCustomContentFont": dataFromModal?.landCustomContentFont || "Poppins",
                        "landingPageContainerContentColour": dataFromModal?.landContainerContentColour || "#ffffff",
                        "landingPageButtonFont": dataFromModal?.landBtnFont || "Poppins",
                        "landingPageButtonText": dataFromModal?.landBtnText || "Let's get started",
                        "landingPageTxtColor": dataFromModal?.landTextColor || "",
                        "buttonTextColor": dataFromModal?.btnTextColor,
                        "loaderColor": dataFromModal?.loaderColor
                    },
                    "additionalProperties": {
                        "Application": applicationPopupData,
                        "Department": departmentPopupData,
                        "UseCase": casePopupData,
                        "Watermark": watermark,
                        "WatermarkPosition": watermarkPosition,
                        "endPoinDetails": {
                            "url": dataFromModal?.endPoint || "",
                            "method": dataFromModal?.endPoint ? "POST" : "",
                            "headers": dataFromModal?.endPointHeaders || ""
                        }
                    },
                    "templateId": dataFromModal?.templateId || ""
                }
            }
            if (editUUID?.length) {
                finalData['formUUID'] = editUUID
                const submissionRes = await updateFormByUUID(finalData)
                const previewLink = await getPreviewLink(editUUID)
                if (previewLink?.formLink) {
                    const parsedId = parseUrl(previewLink.formLink)
                    setFormUUID(parsedId ? parsedId : "");
                }
                if (submissionRes?.status === 200) {
                    setToasterOpen(true)
                    setTimeout(() => {
                        if (sessionStorage.getItem('noWorkspace')) {
                            navigate(`/successEdit?id=${editUUID}`)
                        } else {
                            if (type === 'save' || type === 'unPublish') {
                                setDataFromModal({ ...dataFromModal, isPublished: isPublishedValue })
                                setSelectedMode(sidebarValueConstants.drafted)
                                setdisableIsPublished(false)
                            } else {
                                setDataFromModal({ ...dataFromModal, isPublished: 1 })
                                setSelectedMode(sidebarValueConstants.published)
                                setSuccessPopupOpen(true)
                            }
                            setRedoState([])
                            setHistoryState([])
                        }
                        getFormDetails();
                        setToasterOpen(true)
                        setLoading(false);
                    }, 2000)
                } else {
                    setLoading(false);
                }
            } else {
                const submissionRes = await insertForms(finalData)
                if (submissionRes?.formUUID?.length) {
                    setFormUUID(submissionRes?.formUUID)
                    setEditUUID(submissionRes?.formId)
                    if (type === 'save') {
                        getFormDetails(submissionRes?.formId);
                        setToasterOpen(true);
                        setToasterMessage("Form saved successfully");
                        setToasterSeverity("success");
                        setSelectedMode(sidebarValueConstants.drafted)
                        setdisableIsPublished(false)
                        prepareFormEventsDetails(finalData)
                    } else {
                        setSelectedMode(sidebarValueConstants.published)
                        setSuccessPopupOpen(true)
                    }
                    setRedoState([])
                    setHistoryState([])
                    setLoading(false);
                } else {
                    setSuccessPopupOpen(true)
                    setFormUUID('');
                    setLoading(false);
                }
            }
            setFinalQuestionRes("")
        }, 100) // as we use useState, it takes little amount of time to set the form values and need to perform validations in form so need this settimeout.

    }


    const handleTypeChange = (data: any) => {

        unregisterMethods(formValidator,
            [
                "isRequired",
                "isTimeLimitEnabled",
                "timeLimit",
                "paymentId",
                "currency",
                "amount",
                "name",
                "title",
                "description",
                "dropDependedName",
                "options",
                "styles"
            ])
        setInputType(data?.type)
        switch (data.type) {
            case "input":
                setMasterType(inputFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("input")
                break
            case "richText":
                setMasterType(richTextFormat)
                setOptionCount(0)
                formValidator.reset({ ...data })
                setSelectedType("richText")
                break
            case "multi-input":
                setMasterType(multiInputFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("multi-input");
                break
            case "select":
                setMasterType(singleSelectFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("select")
                break
            case "dropdown":
                setMasterType(dropDownFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("dropdown")
                break
            case "multi-select":
                setMasterType(multiselectFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("multi-select")
                break
            case "phoneNumber":
                setOptionCount(data?.options?.length)
                setMasterType(inputPhoneFormat)
                formValidator.reset({ ...data })
                setSelectedType("phoneNumber")
                break
            case "html":
                setOptionCount(0)
                setMasterType(htmlFormat)
                formValidator.reset({ ...data })
                setSelectedType("html")
                break
            case "payment":
                setOptionCount(0)
                setMasterType(paymentFormat)
                formValidator.reset({ ...data })
                setSelectedType("payment")
                if (!formValidator.getValues('currency')) {
                    formValidator.setValue('currency', "EUR")
                }
                break
            case "date":
                setOptionCount(data?.options?.length)
                setMasterType(dateFormat)
                formValidator.reset({ ...data })
                setSelectedType("date")
                break
            case "dateAndTime":
                setOptionCount(data?.options?.length)
                setMasterType(datetimeFormat)
                formValidator.reset({ ...data })
                setSelectedType("dateAndTime")
                break
            case "time":
                setOptionCount(data?.options?.length)
                setMasterType(timeFormat)
                formValidator.reset({ ...data })
                setSelectedType("time")
                break
            case "nameAndSurname":
                setMasterType(nameSurnameFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("nameAndSurname")
                break
            case "contactInfo":
                setMasterType(contactInfoFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("contactInfo")
                break
            case "domain":
                setMasterType(domainFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("domain")
                break
            case "email":
                setMasterType(emailFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("email")
                break
            case "address":
                setMasterType(addressFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("address")
                break
            case "appointment":
                setOptionCount(0)
                setMasterType(AppointmentJs)
                formValidator.reset({ ...data })
                setSelectedType("appointment")
                break
            case "country":
                setMasterType(countryFormat)
                setOptionCount(0)
                formValidator.reset({ ...data })
                setSelectedType("country")
                break
            case "geolocation":
                setMasterType(geolocationFormat)
                setOptionCount(0)
                formValidator.reset({ ...data })
                setSelectedType("geolocation")
                break
            case "timezone":
                setMasterType(timeZoneFormat)
                setOptionCount(0)
                formValidator.reset({ ...data })
                setSelectedType("timezone")
                break
            case "linkedin":
                setOptionCount(0)
                setMasterType(socialMedia)
                formValidator.reset({ ...data })
                setSelectedType("linkedin")
                break
            case "google":
                setOptionCount(0)
                setMasterType(google)
                formValidator.reset({ ...data })
                setSelectedType("google")
                break
            case "twitter":
                setOptionCount(0)
                setMasterType(socialMedia)
                formValidator.reset({ ...data })
                setSelectedType("twitter")
                break
            case "facebook":
                setOptionCount(0)
                setMasterType(socialMedia)
                formValidator.reset({ ...data })
                setSelectedType("facebook")
                break
            case "openproject":
                setOptionCount(0)
                setMasterType(socialMedia)
                formValidator.reset({ ...data })
                setSelectedType("openproject")
                break
            case "tiktok":
                setOptionCount(0)
                setMasterType(socialMedia)
                formValidator.reset({ ...data })
                setSelectedType("tiktok")
                break
            case "calculation":
                setOptionCount(0)
                setMasterType(calculativeFieldFormat)
                formValidator.reset({ ...data })
                setSelectedType("calculation")
                break
            case "employee":
                setMasterType(employeeDropdownFormat)
                setOptionCount(data?.options?.length)
                formValidator.reset({ ...data })
                setSelectedType("employee")
                break
            case "capture":
                setOptionCount(0)
                setMasterType(captureFormat)
                formValidator.reset({ ...data })
                setSelectedType("capture")
                break
        }
    }

    const handleRedo = () => {
        try {
            const poppedData = redoState.pop()
            if (['formsettings', 'slides'].includes(poppedData.type)) {
                const poppedObject: any = Object.entries(poppedData)
                setHistoryState((prev: any) => [...addValueAndMaintainLength(prev, {
                    ...poppedData, [poppedObject[0][0] === 'inputType' ? 'prevData' : poppedObject[0][0]]: !['add-option-ip', 'remove-option-ip', 'inputType'].includes(poppedObject[0][0])
                        ? formValidator.getValues(poppedObject[0][0]) : poppedObject[0][0] === 'inputType'
                            ? { ...formValidator.getValues(), type: inputType } : poppedObject[0][1] ?? poppedData?.poppedObject[0][1], poppedObject
                })])
                if (poppedObject[0][0] === 'inputType') {
                    setInputType(poppedObject[0][1] ?? poppedData?.poppedObject[0][1])
                    handleTypeChange(poppedObject[2][1])
                } else if (poppedObject[0][0] === 'style.url.switch') {
                    setuploadState(!!poppedObject[0][1])
                } else if (poppedObject[0][0] === 'remove-option-ip') {
                    setRemoveIpOptions({ data: poppedObject[0][1], index: poppedObject[2][1] })
                } else if (poppedObject[0][0] === 'add-option-ip') {
                    setAddIpOptions({ data: poppedObject[0][1], index: poppedObject[2][1] })
                } else {
                    formValidator.setValue(poppedObject[0][0], poppedObject[0][1])
                    if (poppedObject[0][0] === 'isRequired') {
                        setChecked(poppedObject[0][1])
                    } else if (poppedObject[0][0] === 'fetchFromApi') {
                        setIsFetchFromApi(poppedObject[0][1])
                    }
                }
            } else if (poppedData.type === "form-content") {
                setHistoryState((prev: any) => [...addValueAndMaintainLength(prev, {
                    ...poppedData
                })])
                if (poppedData['deleted-question']) {
                    const filteredDataForm = [...dataFormSettings]?.filter((value, key) => key !== poppedData['deleted-question'].index)
                    setDataFormSettings(filteredDataForm)
                    setQuestionFormData([...questionFormData]?.filter((value, key) => key !== poppedData['deleted-question'].index))
                    const selectedIndex = filteredDataForm?.length - 1 > poppedData['deleted-question'].index ? poppedData['deleted-question'].index : poppedData['deleted-question'].index - 1
                    setSelectedFormSettings({ index: selectedIndex, fields: filteredDataForm[selectedIndex] })
                } else if (poppedData['duplicate-question']) {
                    dataFormSettings.splice(poppedData['duplicate-question'].index, 0, poppedData['duplicate-question'].data)
                    setDataFormSettings([...dataFormSettings])
                    questionFormData.splice(poppedData['duplicate-question'].index, 0, poppedData['duplicate-question'].data)
                    setQuestionFormData([...questionFormData])
                    setSelectedFormSettings({ index: poppedData['duplicate-question'].index, fields: poppedData['duplicate-question'].data })
                } else if (poppedData['add-question']) {
                    dataFormSettings.splice(poppedData['add-question'].index, 0, poppedData['add-question'].data)
                    setDataFormSettings([...dataFormSettings])
                    questionFormData.splice(poppedData['add-question'].index, 0, poppedData['add-question'].data)
                    setQuestionFormData([...questionFormData])
                    setSelectedFormSettings({ index: poppedData['add-question'].index, fields: poppedData['add-question'].data })
                } else if (poppedData['swap-question']) {
                    setDataFormSettings(poppedData['swap-question']?.data);
                    setQuestionFormData(poppedData['swap-question']?.data)
                    setSelectedFormSettings({ ...poppedData['selectedFormSettings'] })
                }
            }
            setRedoState([...redoState])
        } catch (e: any) {
            console.error('redo', e.message || e)
        }
    }
    const handleUndo = () => {
        try {
            const poppedData = historyState.pop()
            if (['formsettings', 'slides'].includes(poppedData.type)) {
                const poppedObject: any = Object.entries(poppedData || {})
                setRedoState((prev: any) => [...addValueAndMaintainLength(prev, {
                    ...poppedData, [poppedObject[0][0] === 'inputType' ? 'prevData' : poppedObject[0][0]]: !['add-option-ip', 'remove-option-ip', 'inputType'].includes(poppedObject[0][0])
                        ? formValidator.getValues(poppedObject[0][0]) : poppedObject[0][0] === 'inputType'
                            ? { ...formValidator.getValues(), type: inputType } : poppedObject[0][1] ?? poppedData?.poppedObject[0][1], poppedObject
                })])
                if (poppedObject[0][0] === 'inputType') {
                    setInputType(poppedObject[0][1])
                    handleTypeChange(poppedObject[2][1])
                } else if (poppedObject[0][0] === 'style.url.switch') {
                    setuploadState(!!poppedObject[0][1])
                } else if (poppedObject[0][0] === 'add-option-ip') {
                    setRemoveIpOptions({ data: poppedObject[0][1], index: poppedObject[2][1] })
                } else if (poppedObject[0][0] === 'remove-option-ip') {
                    setAddIpOptions({ data: poppedObject[0][1], index: poppedObject[2][1] })
                } else {
                    formValidator.setValue(poppedObject[0][0], poppedObject[0][1])
                    if (poppedObject[0][0] === 'isRequired') {
                        setChecked(poppedObject[0][1])
                    } else if (poppedObject[0][0] === 'fetchFromApi') {
                        setIsFetchFromApi(poppedObject[0][1])
                    }
                }
            } else if (poppedData.type === "form-content") {
                setRedoState((prev: any) => [...addValueAndMaintainLength(prev, {
                    ...poppedData, selectedFormSettings
                })])
                if (poppedData['deleted-question']) {
                    dataFormSettings.splice(poppedData['deleted-question'].index, 0, poppedData['deleted-question'].data[0])
                    setDataFormSettings([...dataFormSettings])
                    questionFormData.splice(poppedData['deleted-question'].index, 0, poppedData['deleted-question'].data[0])
                    setQuestionFormData([...questionFormData])
                    setSelectedFormSettings({ index: poppedData['deleted-question'].index, fields: poppedData['deleted-question'].data[0] })
                }
                else if (poppedData['duplicate-question']) {
                    const filteredDataForm = [...dataFormSettings]?.filter((value, key) => key !== poppedData['duplicate-question'].index)
                    setDataFormSettings([...filteredDataForm])
                    setQuestionFormData([...questionFormData]?.filter((value, key) => key !== poppedData['duplicate-question'].index))
                    setSelectedFormSettings({ index: poppedData['duplicate-question'].index - 1, fields: filteredDataForm[poppedData['duplicate-question'].index - 1] })
                } else if (poppedData['add-question']) {
                    const filteredDataForm = [...dataFormSettings]?.filter((value, key) => key !== poppedData['add-question'].index)
                    setDataFormSettings([...filteredDataForm])
                    setQuestionFormData([...questionFormData]?.filter((value, key) => key !== poppedData['add-question'].index))
                    setSelectedFormSettings({ index: poppedData['add-question'].index - 1, fields: filteredDataForm[poppedData['add-question'].index - 1] })
                } else if (poppedData['swap-question']) {
                    setDataFormSettings(poppedData['swap-question']?.data); // Update the state with the new order of items
                    setQuestionFormData(poppedData['swap-question']?.data)
                    const selectedFields = poppedData['swap-question']?.data[poppedData['swap-question']?.index]
                    setSelectedFormSettings({ fields: selectedFields, index: poppedData['swap-question']?.index })
                }
            }
            setHistoryState([...historyState])
        } catch (e: any) {
            console.error('undo', e.message || e)
        }
    }

    const deleteLandingPageDetails = () => {
        setLandingPage(false);
        setDataFromModal({ ...dataFromModal, isLanding: false });

        const filterData = cloneDeep(questionFormData)
        setQuestionFormData(filterData)

        const selectedIndex = 0;
        setSelectedFormSettings({ index: selectedIndex, fields: filterData[selectedIndex] })
    }

    const handleContentDelete = (index: any) => {
        if (index === -1) {
            return deleteLandingPageDetails();
        }

        if (questionFormData.length === 1) return
        const delQuestion = dataFormSettings.filter((data: any, key: number) => key === index)
        storeHistory('deleted-question', { data: delQuestion, index }, 'form-content')

        const deletedQuestionOption = delQuestion[0]?.options?.filter((option: any) => option.id)?.map((data: any) => data.id);
        dataFormSettings.forEach((question: any, index: number) => {
            if (question.isDepended) {
                if (typeof question.dependedId === "string") {
                    if (deletedQuestionOption?.includes(question?.dependedId)) {
                        dataFormSettings[index].isDepended = false;
                        dataFormSettings[index].dependedId = "";
                    }
                } else {
                    const removedDependedId = question.dependedId?.filter(
                        (id: string) => !deletedQuestionOption.includes(id)
                    );
                    if (removedDependedId.length === 1)
                        dataFormSettings[index].dependedId = removedDependedId[0];
                    else dataFormSettings[index].dependedId = removedDependedId;
                }
            }
        });

        setDataFormSettings(dataFormSettings?.filter((data: any, key: number) => key !== index))
        const filterData = questionFormData?.filter((data: any, key: number) => key !== index)
        setQuestionFormData(filterData)
        const selectedIndex = index === questionFormData?.length - 1 ? index - 1 : questionFormData?.length === 0 ? "" : questionFormData?.length === index ? index - 1 : index
        setSelectedFormSettings({ index: selectedIndex, fields: selectedIndex === "" ? selectFormat : filterData[selectedIndex] })
    }


    const storeHistory = (fieldName: string, value: any, type: string, optional?: any) => {
        let newValue: any = {}
        setRedoState([])
        if (optional) {
            newValue = { [fieldName]: value, type: 'formsettings' }
            const optionalObjectArray: any = Object.entries(optional)
            newValue[optionalObjectArray[0][0]] = optionalObjectArray[0][1]
        } else {
            newValue = { [fieldName]: value, type }
        }
        setHistoryState((prev: any) => [...addValueAndMaintainLength(prev, newValue)])
    }

    useEffect(() => {
        if (allQuestionTypes) {
            let clonedSettings = dataFormSettings
            if (addNewIndex || addNewIndex === 0) {
                clonedSettings.splice(addNewIndex + 1, 0, selectFormat)
                storeHistory('add-question', { data: selectFormat, index: addNewIndex + 1 }, 'form-content')
                setSelectedFormSettings({ index: addNewIndex + 1, fields: selectFormat })
                setaddNewIndex(null)
            } else {
                clonedSettings.push(selectFormat)
                setSelectedFormSettings({ index: clonedSettings?.length === 0 ? 0 : clonedSettings?.length - 1, fields: selectFormat })
            }
            setAllQuestionTypes(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allQuestionTypes])

    useEffect(() => {
        if (landingPage) {
            setDataFromModal({ ...dataFromModal, html: "", landTextColor: "#ffffff", landBtnColor: "#7654ff" })
        } else {
            let data = { ...dataFromModal }
            delete data.html
            delete data.landTextColor;
            delete data.landBtnColor;
            setDataFromModal({ ...data })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [landingPage])

    useEffect(() => {
        if (endPointAvailable) {
            setDataFromModal({ ...dataFromModal, endPoint: "", endPointMethod: "", endPointHeaders: "" })
        } else {
            let data = { ...dataFromModal }
            delete data.endPoint
            delete data.endPointMethod
            delete data.endPointHeaders
            setDataFromModal(data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endPointAvailable])

    useEffect(() => {
        if (!gaAvailable) {
            let data = { ...dataFromModal }
            delete data.gaTrackingId
            setDataFromModal(data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gaAvailable])

    useEffect(() => {
        if (!gtmAvailable) {
            let data = { ...dataFromModal }
            delete data.gtmTrackingId
            setDataFromModal(data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gtmAvailable])


    const getFormDetails = async (tempEditUUID?: string): Promise<void> => {
        const formDetailsResponse = await getFormsByUUID(
            tempEditUUID ? tempEditUUID : editUUID,
            sessionStorage?.principalId
        );
        if (formDetailsResponse.formData && formDetailsResponse.formData.length) {
            formDetailsResponse.formData.forEach((item: any) => {
                item.timeLimit = item.timeLimit ? item.timeLimit : "";
                item.isTimeLimitEnabled = item.isTimeLimitEnabled
                    ? item.isTimeLimitEnabled
                    : false;
            });

            const formDetailsData = getFormattedResponse(formDetailsResponse);

            setDataFormSettings(formDetailsData);
            setQuestionFormData(formDetailsData)
            setSelectedFormSettings({ index: 0, fields: formDetailsData[0] })
        }
        if (Object.keys(formDetailsResponse)?.length > 0) {
            return formDetailsResponse?.formName || ""
        }
    }

    const handleEditDetails = async () => {
        const formName: any = await getFormDetails()
        const locationDataModal = location?.state?.dataFromModal
        const selectedContactGroupName = getContactGroupName(locationDataModal?.contactGroup);
        setDataFromModal({
            name: formName || locationDataModal?.formName || "",
            backGround: locationDataModal?.style?.background || "",
            submitPageBackground: locationDataModal?.style?.submitPageBackground || "",
            landingPageBackground: locationDataModal?.style?.landingPageBackground || "",
            html: locationDataModal?.formContent,
            finalContent: locationDataModal?.finalContent || "",
            isLanding: locationDataModal?.formContent ? true : false,
            landTextColor: Color(locationDataModal?.style?.landingPageTxtColor || "#ffffff").hex(),
            landBtnColor: Color(locationDataModal?.style?.landingPageButtonColor || "#7654ff").hex(),
            backgroundColor: Color(locationDataModal?.style?.backgroundColor || "#3d3d3d").hex(),
            landBtnFont: locationDataModal?.style?.landingPageButtonFont || "Poppins",
            landBtnText: locationDataModal?.style?.landingPageButtonText || "Let's get started",
            landContentType: locationDataModal?.style?.landingPageContentType || "custom",
            landCustomContentColour: Color(locationDataModal?.style?.landingPageCustomContentColour || "#ffffff").hex(),
            landContainerContentColour: Color(locationDataModal?.style?.landingPageContainerContentColour || "#ffffff").hex(),
            landCustomContentFont: locationDataModal?.style?.landingPageCustomContentFont || "Poppins",
            textColor: Color(locationDataModal?.style?.foregroundColor || "#ffffff").hex(),
            btnColor: Color(locationDataModal?.style?.buttonColor || "#00274E").hex(),
            btnTextColor: Color(locationDataModal?.style?.buttonTextColor || "#ffffff").hex(),
            loaderColor: Color(locationDataModal?.style?.loaderColor || "#ffffff").hex(),
            endPointAvailable: locationDataModal?.additionalProperties?.endPoinDetails?.url ? true : false,
            recordVideo: locationDataModal?.recordVideo ? true : false,
            sendResponseToUser: locationDataModal?.sendResponseToUser ? true : false,
            gaAvailable: locationDataModal?.gaAvailable ? true : false,
            gtmAvailable: locationDataModal?.gtmAvailable ? true : false,
            gaTrackingId: locationDataModal?.gaTrackingId,
            gtmTrackingId: locationDataModal?.gtmTrackingId,
            showRecordVideo: locationDataModal?.showRecordVideo ? true : false,
            saveContact: locationDataModal?.saveContact ? true : false,
            formLink: locationDataModal?.formLink || "",
            endPoint: locationDataModal?.additionalProperties?.endPoinDetails?.url || "",
            endPointMethod: locationDataModal?.additionalProperties?.endPoinDetails?.method || "",
            endPointHeaders: locationDataModal?.additionalProperties?.endPoinDetails?.headers || "",
            contactGroup: selectedContactGroupName,
            isPublished: locationDataModal?.isPublished || 0,
            allowNewResponse: locationDataModal?.allowNewResponse || false,
            sendResponseInEmail: {
                isActive: location?.state?.dataFromModal?.sendResponseInEmail?.isActive ?? false,
                sendersEmail: location?.state?.dataFromModal?.sendResponseInEmail?.sendersEmail ?? "",
                recipientsEmail: location?.state?.dataFromModal?.sendResponseInEmail?.recipientsEmail ?? [],
                subject: location?.state?.dataFromModal?.sendResponseInEmail?.subject ?? ""
            },
            templateId: locationDataModal?.templateId || ""
        })
        setEndPointAvailable(locationDataModal?.additionalProperties?.endPoinDetails?.url ? true : false)
        setCasePopupData(locationDataModal?.additionalProperties?.UseCase);
        setWatermark(locationDataModal?.additionalProperties?.Watermark)
        setWatermarkPosition(locationDataModal?.additionalProperties?.WatermarkPosition)
        setApplicationPopupData(locationDataModal?.additionalProperties?.Application);
        setDepartmentPopupData(locationDataModal?.additionalProperties?.Department)
        setRecordVideo(locationDataModal?.recordVideo ? true : false,)
        setShowRecordVideo(locationDataModal?.showRecordVideo ? true : false);
        setSaveContact(locationDataModal?.saveContact ? true : false);
        setSendResponseToUser(locationDataModal?.sendResponseToUser ? true : false)
        setGaAvailable(locationDataModal?.gaAvailable ? true : false)
        setGtmAvailable(locationDataModal?.gtmAvailable ? true : false)
        setGaTrackingId(locationDataModal?.gaTrackingId)
        setGtmTrackingId(locationDataModal?.gtmTrackingId)
        setContactGroup(selectedContactGroupName)
        setSaveContact(locationDataModal?.saveContact || false)
        if (locationDataModal?.formLink) {
            const parsedId = parseUrl(location.state.dataFromModal.formLink)
            setFormUUID(parsedId ? parsedId : "");
        }
        setTimeout(() => {
            setHistoryState([])
        }, 2000) //need this delay to reset state
    }

    useEffect(() => {
        if (editUUID?.length && !isNewForm) {
            handleEditDetails()
        }
        return () => {
            setContactGroup("")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editUUID])

    useEffect(() => {
        if (saveContact) {
            let data = { ...dataFromModal }
            data.contactGroup = dataFromModal.contactGroup ?? "";
            setDataFromModal(data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveContact])

    const formDeleteHandler = async () => {
        await deleteFormByUUID(editUUID, sessionStorage?.principalId, 'soft');
        navigate('/workspace')
    }

    const handleDeleteClick = () => {
        setFormDelete(true)
    }

    const handleShareClick = () => {
        setShareMode(true)
    }
    const handlePreviewClick = async () => {
        setSubmitType("finalSubmit")
        setSubmitToggle(!submitToggle)

        setTimeout(async () => {
            const allQuestionData = [...questionFormDataRef?.current];
            const isValid = handleValidation(allQuestionData)

            const { hasErrorInCreateFormPopup } =
                popoverSubmit?.current?.getValidationStatus();

            if (!isValid) {
                setLoading(false)
                return
            }

            if (hasErrorInCreateFormPopup) {
                setLoading(false);
                handleShowPopup();
                return;
            }

            setPreviewMode(true)
            const newQuestionData = allQuestionData?.map((questionData: any, index: number) => {
                questionData['qNo'] = index;
                questionData['type'] = (["nameAndSurname", "address", "domain", "email", "contactInfo"]).includes(questionData['type']) ? "input" : questionData['type']
                return questionData
            })
            const data = {
                landingPage: {
                    "formUUID": editUUID,
                    "formName": dataFromModal?.name,
                    "principalId": sessionStorage.getItem('principalId'),
                    "formContent": dataFromModal?.html,
                    "finalContent": dataFromModal?.finalContent,
                    "style": {
                        "background": dataFromModal?.backGround,
                        "landingPageBackground": dataFromModal?.landingPageBackground,
                        "submitPageBackground": dataFromModal,
                        "foregroundColor": dataFromModal?.textColor,
                        "buttonColor": dataFromModal?.btnColor,
                        "backgroundColor": dataFromModal?.backgroundColor,
                        "fontFamily": "Poppins, sans-serif",
                        "landingPageButtonColor": dataFromModal?.landBtnColor,
                        "landingPageButtonFont": dataFromModal?.landBtnFont,
                        "landingPageButtonText": dataFromModal?.landBtnText,
                        "landingPageContentType": dataFromModal?.landContentType,
                        "landingPageContainerContentColour": dataFromModal?.landContainerContentColour,
                        "landingPageCustomContentColour": dataFromModal?.landCustomContentColour,
                        "landingPageCustomContentFont": dataFromModal?.landCustomContentFont,
                        "landingPageTxtColor": dataFromModal?.landTextColor,
                        "buttonTextColor": dataFromModal?.btnTextColor,
                        "loaderColor": dataFromModal?.loaderColor,
                        "sendResponseInEmail": dataFromModal?.sendResponseInEmail
                    },
                    "additionalProperties": {
                        "Application": applicationPopupData,
                        "Department": departmentPopupData,
                        "UseCase": casePopupData,
                        "Watermark": watermark,
                        "WatermarkPosition": watermarkPosition,
                        "endPoinDetails": {
                            "url": dataFromModal?.endPoint,
                            "method": dataFromModal?.endPointMethod,
                            "headers": dataFromModal?.endPointHeaders,
                        }
                    },
                    "recordVideo": dataFromModal?.recordVideo,
                    "showRecordVideo": dataFromModal?.showRecordVideo,
                    "sendResponseToUser": dataFromModal?.sendResponseToUser,
                    "gaAvailable": dataFromModal?.gaAvailable,
                    "gtmAvailable": dataFromModal?.gtmAvailable,
                    "gaTrackingId": dataFromModal?.gaTrackingId,
                    "gtmTrackingId": dataFromModal?.gtmTrackingId,
                    "allowNewResponse": dataFromModal?.allowNewResponse,

                },
                formData: newQuestionData
            }

            setTimeout(() => {
                const message = { event: 'dataUpdate', payload: data };
                const iframe: any = document.querySelector('#conversational-forms-Iframe');

                iframe.contentWindow.postMessage(message, '*')
            }, 1000)

            setSubmitType("")
        }, 100)// as we use useState, it takes little amount of time to set the form values and need to perform validations in form so need this settimeout.
    };

    const prepareFormEventsDetails = (formData: any) => {
        conversationalFormEvents.data.form_name = formData?.formName;
        conversationalFormEvents.dwh.Timestamp = Math.floor(Date.now() / 1000);
        // background_settings
        conversationalFormEvents.data.background_settings.background_url = formData?.landingPageData?.style?.background
        conversationalFormEvents.data.background_settings.submit_page_background_url = formData?.landingPageData?.style?.submitPageBackground
        conversationalFormEvents.data.background_settings.background_color = formData?.landingPageData?.style?.backgroundColor

        // welcome_page_settings
        conversationalFormEvents.data.welcome_page_settings.enabled = formData?.isLandingNeeded
        conversationalFormEvents.data.welcome_page_settings.background_url = formData?.landingPageData?.style?.landingPageBackground
        conversationalFormEvents.data.welcome_page_settings.text = formData?.landingPageData?.formContent
        conversationalFormEvents.data.welcome_page_settings.text_color = formData?.landingPageData?.style?.landingPageTxtColor
        conversationalFormEvents.data.welcome_page_settings.button_color = formData?.landingPageData?.style?.buttonTextColor

        // thank_you_page
        conversationalFormEvents.data.thank_you_page.html = formData?.landingPageData?.finalContent
        conversationalFormEvents.data.thank_you_page.vertical_center = isCenteredContant(formData?.landingPageData?.finalContent, 'align-items: center')
        conversationalFormEvents.data.thank_you_page.horizontal_center = isCenteredContant(formData?.landingPageData?.finalContent, 'justify-content: center')

        // conversational_form_settings
        const { Application = "string", Department = "string", UseCase = "string", Watermark = 'string', WatermarkPosition = "string" } = formData?.landingPageData?.additionalProperties || {};
        conversationalFormEvents.data.conversational_form_settings.application = Application;
        conversationalFormEvents.data.conversational_form_settings.department = Department
        conversationalFormEvents.data.conversational_form_settings.use_case = UseCase
        conversationalFormEvents.data.conversational_form_settings.watermark.enabled = Watermark
        conversationalFormEvents.data.conversational_form_settings.watermark.position = WatermarkPosition

        // contacts
        conversationalFormEvents.data.general_settings.text_color = formData?.landingPageData?.foregroundColor;
        conversationalFormEvents.data.general_settings.button_color = formData?.landingPageData?.buttonColor;
        conversationalFormEvents.data.general_settings.button_text_color = formData?.landingPageData?.buttonTextColor;
        conversationalFormEvents.data.general_settings.loader_color = formData?.landingPageData?.loaderColor;
        conversationalFormEvents.data.general_settings.record_video = formData?.landingPageData?.recordVideo;
        conversationalFormEvents.data.general_settings.allow_new_responses = formData?.landingPageData?.allowNewResponse;
        conversationalFormEvents.data.general_settings.display_recorded_video = formData?.landingPageData?.showRecordVideo;
        conversationalFormEvents.data.general_settings.google_analytics = formData?.landingPageData?.gaAvailable;
        conversationalFormEvents.data.general_settings.gtm = formData?.landingPageData?.gtmAvailable;
        conversationalFormEvents.data.general_settings.send_response_to_user = formData?.landingPageData?.sendResponseToUser;
        conversationalFormEvents.data.general_settings.send_data_to_endpoint = formData?.landingPageData?.endPointAvailable;
        conversationalFormEvents.data.general_settings.email_submission = formData?.landingPageData?.saveContact;
        conversationalFormEvents.data.event_info.cookie_id = getCookie('routee_cookie') || 'cookie_id'

        sendWaymoreSystemEvents(conversationalFormEvents)

    }

    useEffect(() => {
        if (previewMode) {
            const message = { event: 'previewType', payload: previewType };
            const iframe: any = document.querySelector('#conversational-forms-Iframe');

            iframe.contentWindow.postMessage(message, '*')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [previewType])


    useEffect(() => {
        try {
            if (!groupsList?.length) {
                getGroups().then((group) => setGroupsList(handleDropdownData(group?.data)))
            }
        } catch (e) {
            console.error("error in getGroups", e);
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setOpenLogicDialog(false);
    }, [setOpenLogicDialog]);

    return (
        <React.Fragment>
            <RootContainer style={{ display: (previewMode || shareMode) ? "none" : "block" }}>
                <FormHeader
                    type="form"
                    isNewForm={isNewForm}
                    title={popoverSubmit?.current?.getTitle("name")}
                    onPreviewClick={handlePreviewClick}
                    onShareClick={handleShareClick}
                    onDeleteClick={handleDeleteClick}
                    onSettingsClick={() => {
                        setPopupOpen(true);
                    }}
                    onSaveClick={(type: string) => {
                        handleFinalSubmit(type);
                    }}
                    isPublished={dataFromModal?.isPublished || 0}
                    disableIsPublished={disableIsPublished}
                    formUUID={formUUID}
                />
                <BodyContainer>
                    <FormBodyHeader
                        handleUndo={handleUndo}
                        handleRedo={handleRedo}
                        undoDisabled={!historyState?.length}
                        redoDisabled={!redoState?.length}
                        previewType={previewType}
                        setPreviewType={setPreviewType}
                        onExitClick={() => {
                            if (historyState?.length) {
                                setExitPopupOpen(true);
                            } else {
                                navigate('/workspace');
                            }
                        }}
                    />
                    <BodyContentContainer>
                        <LayoutRoot container>
                            <FormProvider {...methods}>
                                <ContentScreenLayout item xs={2.5}>
                                    <ContentCard
                                        dragDisable={dragDisable}
                                        setPrevSelected={setPrevSelected}
                                        setSubmitType={setSubmitType}
                                        setSubmitToggle={setSubmitToggle}
                                        submitToggle={submitToggle}
                                        setQuestionFormData={setQuestionFormData}
                                        setAllQuestionTypes={setAllQuestionTypes}
                                        dataFormSettings={dataFormSettings}
                                        setDataFormSettings={setDataFormSettings}
                                        selectedData={selectedFormSettings}
                                        handleSelected={setSelectedFormSettings}
                                        handleDelete={(index: number) => {
                                            setDelIndex(index);
                                            setOpenDeletePopup(true);
                                        }}
                                        landingPage={landingPage}
                                        setaddNewIndex={setaddNewIndex}
                                        contextMenu={contextMenu}
                                        setContextMenu={setContextMenu}
                                        storeHistory={storeHistory}
                                        formState={formValidator}
                                        dataFromModal={dataFromModal}
                                        background=""
                                    />
                                </ContentScreenLayout>
                                <QuestionPanelLayout item xs={6.5}>
                                    <div className="form-slides-container">
                                        <Slides
                                            editUUID={editUUID}
                                            previewType={previewType}
                                            inputType={inputType}
                                            background=""
                                            selectedData={selectedFormSettings}
                                            landingPage={landingPage}
                                            formState={formValidator}
                                            masterType={masterType}
                                            setMasterType={setMasterType}
                                            selectedType={selectedType}
                                            setSelectedType={setSelectedType}
                                            fieldIndex={optionIndex}
                                            setFieldIndex={setOptionIndex}
                                            dataFromModal={dataFromModal}
                                            storeHistory={storeHistory}
                                            dropdown={dropdown}
                                            setDropdown={setDropdown}
                                            setRedoState={setRedoState}
                                            prevSelected={prevSelected}
                                            watermarkPosition={watermarkPosition}
                                            methods={formValidator}
                                        />
                                    </div>
                                </QuestionPanelLayout>
                            </FormProvider>
                            <QuestionScreenLayout item xs={3}>
                                {!selectedFormSettings?.fields?.html && (
                                    <FormSettings
                                        errorType={errorType}
                                        setErrorType={setErrorType}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        toastr={toastr}
                                        setToastr={setToastr}
                                        addNewIndex={addNewIndex}
                                        trigger={trigger}
                                        setDragDisable={setDragDisable}
                                        dataFromModal={dataFromModal}
                                        editUUID={editUUID}
                                        setFinalQuestionRes={setFinalQuestionRes}
                                        prevSelected={prevSelected}
                                        submitType={submitType}
                                        setSubmitType={setSubmitType}
                                        submitToggle={submitToggle}
                                        inputType={inputType}
                                        setInputType={setInputType}
                                        setQuestionFormData={setQuestionFormData}
                                        setAllValues={setDataFormSettings}
                                        allValues={dataFormSettings}
                                        selectedData={selectedFormSettings}
                                        setSelectedData={setSelectedFormSettings}
                                        isEdit={editUUID?.length ? true : false}
                                        setAllQuestionTypes={setAllQuestionTypes}
                                        handleDelete={(index: number) => handleContentDelete(index)}
                                        masterType={masterType}
                                        setMasterType={setMasterType}
                                        selectedType={selectedType}
                                        setSelectedType={setSelectedType}
                                        methods={formValidator}
                                        fieldIndex={optionIndex}
                                        setFieldIndex={setOptionIndex}
                                        setSelectedFormSettings={setSelectedFormSettings}
                                        errorTrigger={errorTrigger}
                                        setHistoryState={setHistoryState}
                                        historyState={historyState}
                                        isfetchFromApi={isfetchFromApi}
                                        redoState={redoState}
                                        setRedoState={setRedoState}
                                        setIsFetchFromApi={setIsFetchFromApi}
                                        checked={checked}
                                        setChecked={setChecked}
                                        setaddNewIndex={setaddNewIndex}
                                        storeHistory={storeHistory}
                                        formValidator={formValidator}
                                        landingPage={landingPage}
                                        setDataFromModal={setDataFromModal}
                                        allQuestionFormData={questionFormData}
                                    />
                                )}
                            </QuestionScreenLayout>
                        </LayoutRoot>
                    </BodyContentContainer>
                </BodyContainer>
            </RootContainer>
            <ConversationalFormSettingsDialog
                open={popupOpen}
                closeHandler={() => {
                    setPopupOpen(false);

                    if (!isNewForm) {
                        setDataFromModal(cloneDeep(dataFromModal));
                    }
                }}
                submitHandler={() => {
                    const { hasErrorInCreateFormPopup } =
                        popoverSubmit?.current?.getValidationStatus();

                    if (hasErrorInCreateFormPopup) {
                        popoverSubmit?.current?.scrollToErrorField();
                    } else {
                        popoverSubmit?.current?.submitHandler();
                    }
                }}
                renderContent={() => {
                    return PopupContent({
                        landingPage,
                        setLandingPage,
                        dataFromModal,
                        setDataFromModal,
                        handlingModalData,
                        setEndPointAvailable,
                        endPointAvailable,
                        editUUID,
                        recordVideo,
                        setRecordVideo,
                        showRecordVideo,
                        setShowRecordVideo,
                        sendResponseToUser,
                        setSendResponseToUser,
                        gaAvailable,
                        setGaAvailable,
                        gtmAvailable,
                        setGtmAvailable,
                        gaTrackingId,
                        gtmTrackingId,
                        applicationPopupData,
                        setApplicationPopupData,
                        departmentPopupData,
                        setDepartmentPopupData,
                        setWatermark,
                        watermark,
                        setWatermarkPosition,
                        watermarkPosition,
                        casePopupData,
                        setCasePopupData,
                        popoverSubmit,
                        saveContact,
                        setSaveContact,
                        contactGroup,
                        setContactGroup
                    });
                }}
            />
            {
                <PreviewRootContainer style={{ display: previewMode ? "block" : "none" }}>
                    <PreviewHeader ModeHeading="Preview Mode" />
                    <PreviewBodyContainer>
                        <PreviewBodyHeader
                            previewType={previewType}
                            setPreviewType={setPreviewType}
                            handlePreviewClick={handlePreviewClick}
                            onExitClick={() => {
                                setPreviewMode(false);
                            }}
                        />
                        <PreviewBodyContentContainer>
                            <IframeParentContainer style={{ display: previewMode ? "flex" : "none" }}>
                                <Iframe
                                    id="conversational-forms-Iframe"
                                    className={`conversational-forms-Iframe`}
                                    url={`${conversationalFormsURL}/?mode=preview`}
                                />
                            </IframeParentContainer>
                        </PreviewBodyContentContainer>
                    </PreviewBodyContainer>
                </PreviewRootContainer>
            }
            {
                <ShareRootContainer style={{ display: shareMode ? "block" : "none" }}>
                    <PreviewHeader ModeHeading="Share Mode" />
                    <ShareBodyContainer>
                        <PreviewBodyHeader
                            handleShareClick={handleShareClick}
                            onExitClick={() => {
                                setShareMode(false);
                            }}
                            previewType={previewType}
                            isShareMode={true}
                            setPreviewType={setPreviewType}
                        />
                        <ShareBodyContentContainer>
                            <IframeParentContainer style={{ display: shareMode ? "flex" : "none" }}>
                                {editUUID && formUUID && <Embedding editUUID={editUUID} formUUID={formUUID} previewType={previewType} shareMode={shareMode} />}
                            </IframeParentContainer>
                        </ShareBodyContentContainer>
                    </ShareBodyContainer>
                </ShareRootContainer>
            }

            <PublishAlertModal
                isOpen={successPopupOpen}
                formUUID={formUUID}
                setToasterOpen={setToasterOpen}
                setToasterMessage={setToasterMessage}
                setToasterSeverity={setToasterSeverity}
                closeHandler={() => {
                    setSuccessPopupOpen(false);
                }}
            />
            <ExitConfirmationModal
                isOpen={exitPopupOpen}
                closeHandler={() => {
                    setExitPopupOpen(false);
                }}
                cancelHandler={() => {
                    navigate('/workspace');
                    setExitPopupOpen(false);
                }}
                submitHandler={() => {
                    handleFinalSubmit();
                    setExitPopupOpen(false);
                }}
            />
            <DeleteConfirmationModal
                isOpen={OpenDeletePopup}
                cancelHandler={() => {
                    setDelIndex(null);
                    setOpenDeletePopup(false);
                }}
                submitHandler={() => {
                    handleContentDelete(delIndex);
                    setOpenDeletePopup(false);
                    setDelIndex(null);
                }}
                cancelText="Cancel"
                submitText="Delete"
                contentText="Are you sure that you want to delete this page?"
            />
            <DeleteConfirmationModal
                isOpen={formDelete}
                cancelHandler={() => {
                    setFormDelete(false);
                }}
                submitHandler={() => {
                    formDeleteHandler();
                    setFormDelete(false);
                }}
                cancelText="Cancel"
                submitText="Delete"
                contentText="Are you sure that you want to delete this form?"
            />
            <DeleteConfirmationModal
                isOpen={contactFieldWarningOpen}
                cancelHandler={() => {
                    setContactFieldWarningOpen(false);
                }}
                submitHandler={() => {
                    setContactFieldWarningOpen(false);
                }}
                submitText="OK"
                hideCancelButton={true}
                contentText="To save submissions as contacts, add at least one Email or Phone Number field to the form."
            />
            <Snackbar
                open={toasterOpen}
                autoHideDuration={3000}
                onClose={() => {
                    setToasterOpen(false);
                    setToasterMessage("");
                    setToasterSeverity("");
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert
                    variant="filled"
                    severity={toasterSeverity ? toasterSeverity : "success"}
                    onClose={() => {
                        setToasterOpen(false);
                        setToasterMessage("");
                        setToasterSeverity("");
                    }}
                >
                    {toasterMessage ? toasterMessage : "Updated successfully"}
                </Alert>
            </Snackbar>
            <Backdrop
                open={loading}
                sx={{
                    color: "#fff",
                    zIndex: (theme: any) => previewMode ? 0 : theme.zIndex.drawer + 1,
                }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </React.Fragment>
    );
}
